import { render, staticRenderFns } from "./extra-info-component.vue?vue&type=template&id=64134d98"
import script from "./extra-info-component.vue?vue&type=script&lang=js"
export * from "./extra-info-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports